import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { UserService } from '../user/user.service';

import { Observable } from 'rxjs';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {
  constructor(private readonly userService: UserService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headers = this.getHeaders(request);

    return next.handle(request.clone({ headers }));
  }

  private getHeaders(request: HttpRequest<any>): HttpHeaders {
    let { headers } = request;
    const active_tenant = this.userService.getCurrentTenant();

    // TEMP: For B2C migration
    if (active_tenant) {
      headers = headers.set('x-company', active_tenant);
      //INFO: Adding x-email and x-user to header when the request URL is not for the admin tool and not in the production environment.
      if (
        !environment.production &&
        !request.url.includes(environment.ADMIN_TOOL_URL)
      ) {
        const user = JSON.parse(
          localStorage.getItem(`${environment.localStorageKeyPrefix}_auth`) ||
            '{"tokenDetails": {"idTokenClaims" : {}}}'
        );
        const tokenDetails = user.tokenDetails?.idTokenClaims || {};
        const userName = tokenDetails.email
          ? tokenDetails.email
          : tokenDetails.verified_email;
        headers = headers.append('x-email', userName);
        headers = headers.append('x-user', userName);
      }
    }

    headers = headers.set('x-solution', environment.SOLUTION);

    return headers;
  }
}
